// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedCornealTopography_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3.03329 19.975C1.14639 17.855 0 15.0614 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 12.8084 23.9201 13.5982 23.7676 14.3618L23.7562 14.4184C23.4967 15.6866 23.0372 16.8819 22.412 17.9699C22.1997 18.3392 21.9684 18.6962 21.7194 19.0395L19.5776 17.4332C19.4545 16.5771 19.151 15.6699 18.6245 14.758C16.7636 11.5349 13.561 10.7533 11.7274 11.8119C10.7829 12.3572 10.0796 13.4614 9.87403 14.8445L7.85153 16.3614C7.62848 13.7277 8.64326 11.2831 10.7274 10.0798C13.8363 8.28492 18.1475 9.9317 20.3566 13.758C20.7424 14.4263 21.0386 15.1169 21.2481 15.8111C21.4281 15.3749 21.5781 14.9232 21.6955 14.4586C21.4426 13.7723 21.1201 13.0806 20.7225 12.3921C17.7307 7.21006 12.4592 5.61592 9.22736 7.48181C6.53211 9.03792 5.21162 13.0258 6.5828 17.3129L4.90846 18.5687C3.01281 13.4295 4.28545 8.02563 8.22736 5.74976C12.5231 3.26962 18.4509 5.39211 21.8854 10.4812C21.1537 5.67912 17.0065 2 12 2C6.47715 2 2 6.47715 2 12C2 14.6113 3.00093 16.9889 4.64006 18.77L3.03329 19.975Z" class="svg-bg"/>
  <path d="M9 24V22H17V24L21 21L17 18V20H9V18L5 21L9 24Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedCornealTopography is a generated icon component.
 */
let IconMedCornealTopography = IconMedCornealTopography_1 = class IconMedCornealTopography extends IconBaseElement {
    render() {
        return html `${IconMedCornealTopography_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedCornealTopography.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedCornealTopography = IconMedCornealTopography_1 = __decorate([
    customElement('zui-icon-med-corneal-topography')
], IconMedCornealTopography);
export { IconMedCornealTopography };
